
import { Utilidades } from "@/Util/Utilidades";
import { AuthService } from "@/services/Auth";
import Vue from "vue";
import { PlanRenovacionAutomatica } from "@/model/Plan";
import { PlanService } from "@/services/PlanService";
import { Constantes } from "@/Util/Constantes";

export default Vue.extend({
  name: "Footer",
  watch: {
    "$store.state.version": {
      immediate: true,
      deep: true,
      handler() {
        this.version = this.$store.state.version;
      },
    },
  },
  data() {
    return {
      mensaje_plan: "" as string,
      mostrar_mensaje_plan: false as boolean,
      version: "" as String,
      mostrar_boton_contratar_plan: false as boolean,
      renovacion_automatica_activa: false as boolean,      
      loadingRA: false as boolean,    
      id_empresa_plan_contratado_periodo: "" as string,
    };
  },
  mounted() {
    let usuario = AuthService.getUsuario();

    if(usuario){
      let dias_caducidad_plan = usuario?.dias_caducidad_plan;
      this.mostrar_boton_contratar_plan = usuario.enc_puede_renovar_plan == Utilidades.UNO;
      this.renovacion_automatica_activa = usuario.enc_renovacion_automatica == Utilidades.UNO;
      this.id_empresa_plan_contratado_periodo = usuario.id_empresa_plan_contratado_periodo;

      this.mensaje_plan = Utilidades.traduccion({
        texto: "Su plan caducará en #DIAS# dia(s)",
        tag: "SU_PLAN_CADUCAR_EN_#DIAS#_DIAS",
      });

      this.mensaje_plan = this.mensaje_plan.replaceAll(
        "#DIAS#",
        dias_caducidad_plan.toString()
      );
      
      if ((Utilidades.isNullOrUndefinedOrZero(dias_caducidad_plan) || dias_caducidad_plan <= 7) && this.mostrar_boton_contratar_plan) {
        this.mostrar_mensaje_plan = true;
      }
    }

  },
  methods: {
    renovar_plan() {
      let usuario = AuthService.getUsuario();

      if (usuario) {
        
        this.$router.push({
          name: "contratar_plan",
          params: { id: usuario.id, empresa: usuario.id_empresa,
              plan: usuario.id_plan_contratado, periodo: usuario.id_periodo_plan },
        });

      } else {
        Utilidades.Message({
          message: "Error al coger el usuario.",
          error: true,
        });
      }
    },
    async cambiarRenovacionAutomatica(): Promise<void> {
      this.loadingRA = true;
      let item = new Object() as PlanRenovacionAutomatica;
      item.id_empresa_plan_contratado_periodo = this.id_empresa_plan_contratado_periodo;

      await PlanService.cambiarRenovacionAutomaticaAsync(item)
        .then(async (x) => {
          this.renovacion_automatica_activa = !this.renovacion_automatica_activa;
          Utilidades.Message({ message: Constantes.ACTUALIZAR_DATOS });
        })
        .catch((err) => {
          Utilidades.Message({ message: err.response.data, error: true });
        })
        .finally(() => {
          this.loadingRA = false;
        });
    },
    getYear() {
      return new Date().getUTCFullYear();
    },
    oppenautas() {
      return Utilidades.OPENNAUTAS();
    },
  },
});
